export const DividerZigZag = {
  transclude: true,

  template: `
    <div class="divider-zig-zag">
      <ng-transclude></ng-transclude>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Dividers/ZigZag.js